"use strict";

var _taggedTemplateLiteral = require("/home/circleci/poc-carditas-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 8px;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        color: ", ";\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyGutterBottom = exports.typographyWeight = exports.typographyColor = exports.typographyDisplay = void 0;

var _stylitas = require("@creditas/stylitas");

var typographyDisplay = function typographyDisplay(_ref) {
  var display = _ref.display;
  return display && (0, _stylitas.css)(_templateObject(), display);
};

exports.typographyDisplay = typographyDisplay;

var typographyColor = function typographyColor(_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;

  if (!color) {
    return null;
  }

  switch (color) {
    case 'danger':
      return (0, _stylitas.css)(_templateObject2(), theme.bColordanger);

    case 'info':
      return (0, _stylitas.css)(_templateObject3(), theme.bColorinfo);

    case 'success':
      return (0, _stylitas.css)(_templateObject4(), theme.bColorsuccess);

    case 'warning':
      return (0, _stylitas.css)(_templateObject5(), theme.bColorwarning);

    default:
      return (0, _stylitas.css)(_templateObject6(), color);
  }
};

exports.typographyColor = typographyColor;

var typographyWeight = function typographyWeight(_ref3) {
  var weight = _ref3.weight;
  return weight && (0, _stylitas.css)(_templateObject7(), weight);
};

exports.typographyWeight = typographyWeight;

var typographyGutterBottom = function typographyGutterBottom(_ref4) {
  var gutterBottom = _ref4.gutterBottom;
  return gutterBottom && (0, _stylitas.css)(_templateObject8());
};

exports.typographyGutterBottom = typographyGutterBottom;